import React from 'react';
import PropTypes from 'prop-types';

const Table = props => (
  <div className="module-table top">
    <table>
      <thead>
        <tr>
          <th className="left">Fecha</th>
          <th className="left">Tarea</th>
          <th className="left">Conductor</th>
          <th className="left">Equipo</th>
          <th className="left">Estado</th>
        </tr>
      </thead>
      <tbody>
        {props.datos.map((item, i) => (
          <tr
            key={`t-tasks-table-${i}`}
            onClick={function(_idTask, _handleTaskClick, obj) {
              _handleTaskClick(15596018, i);
            }.bind(null, item.id, props.handleClickTask)}
            className={props.actualTask == i ? 'active hover' : 'hover'}
          >
            <td>{item.date}</td>
            <td>{item.task}</td>
            <td>{item.driver}</td>
            <td>{item.vehicle}</td>
            <td>{props.language.summary.nfa[item.state.toLowerCase()]}</td>
          </tr>
        ))}
      </tbody>
    </table>
    {props.loadingTable && (
      <div className="loading-table">
        <h6>
          <i className="fas fa-spinner fa-spin" />
        </h6>
      </div>
    )}
    {props.pag >= props.count.pages && (
      <div className="loading-table">
        <h6>{props.datos.length > 0 ? 'No hay más datos' : 'No hay datos'}</h6>
      </div>
    )}
  </div>
);

export default Table;



// WEBPACK FOOTER //
// ./source/client/components/detail_nfa/table.jsx